;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"orion-web@5382a4811e03381d59a465ceaf6c16cadf5304daed96cf88e1668176"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.25";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/services/orion-web/5382a4811e03381d59a465ceaf6c16cadf5304daed96cf88e1668176";globalThis["_sentryAssetPrefix"] = "https://static.parastorage.com/services/orion-web/5382a4811e03381d59a465ceaf6c16cadf5304daed96cf88e1668176";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs';

import { ORION_WEB_SENTRY_DSN } from './lib/sentry-dsn';
import { classifyErrorSource } from './lib/sentry-error-source';
import { restoreCdnFrameUrls } from './lib/sentry-frame-urls';
import { redactTokenUrls } from './lib/sentry-token-urls';

// Next.js + withSentryConfig (next.config.js) load this file into the client bundle before the app
// hydrates, so Sentry.init always runs — the guards below are what keep it a no-op until there's a
// real DSN and in local dev. (This is the current convention; the older `sentry.client.config.ts`
// name is deprecated in @sentry/nextjs v8+ and stops working under Turbopack.)
// Kept out of app_logs' way: this ADDS grouping/alerting on top of the existing
// reportClientError() -> /api/client-error -> Grafana app_logs path, never replaces it.
if (ORION_WEB_SENTRY_DSN && process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: ORION_WEB_SENTRY_DSN,
    environment: 'production',
    // Matches the server's release (sentry.server.config.ts) so a browser event resolves against
    // the same release — and the source-map artifact bundles the Falcon plugin uploads under it
    // (see next.config.js). Until this is populated a browser stack stays minified: the bundles
    // are in the project, associated to `orion-web@<version>`, with nothing to pair them to.
    release: process.env.NEXT_PUBLIC_ORION_WEB_RELEASE || undefined,
    // Error tracking only for now — no perf/session-replay noise or cost until asked for.
    tracesSampleRate: 0,
    // The callback form APPENDS to the SDK's defaults. An array would too — `getIntegrationsToSetup`
    // in @sentry/core does `[...defaultIntegrations, ...userIntegrations]`, and @sentry/browser's
    // `init` fills `defaultIntegrations` when the caller omits it — but losing the global error
    // handlers and breadcrumbs here would be silent and would take the whole project down with it,
    // so say it in a way that cannot depend on that behaviour holding across an SDK upgrade.
    integrations: (defaults) => [
      ...defaults,
      // Compares every frame against the `orion-web` bundle key that next.config.js's
      // `applicationKey` injects, and tags an event whose frames are ALL from code we did not
      // ship. This is the mechanism Wix's Sentry Best Practices Guide names for third-party
      // noise, and it beats a hand-kept list of filenames because it reads provenance.
      //
      // `apply-tag-…`, never `drop-error-…`: the guide offers both, and a dropped event cannot be
      // reconsidered. `…exclusively…` rather than `…contains…` so an error of OURS that merely
      // passes through a vendor frame stays ours.
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['orion-web'],
        behaviour: 'apply-tag-if-exclusively-contains-third-party-frames',
      }),
    ],
    // Runs last, after the integration above has had its say, and narrows its one bit into WHICH
    // third party — plus the one case it cannot see, an ad blocker refusing a beacon. Always
    // returns the event; see lib/sentry-error-source.ts for why. Triage view:
    // `is:unresolved error_source:app`.
    beforeSend(event) {
      event.tags = { ...event.tags, error_source: classifyErrorSource(event) };
      // Last thing before the event leaves, so the filenames Sentry symbolicates against are the
      // ones the maps were uploaded under. Classification runs first: it reads the same filenames
      // and there is no reason to make it reason about two spellings of them.
      restoreCdnFrameUrls(event, process.env.NEXT_PUBLIC_ORION_WEB_CDN_URL || '');
      return redactTokenUrls(event);
    },
  });
}
